import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { ChartFilters } from "@/components/chart-filters";
import { DownloadsChart } from "@/components/charts/downloads";
import { useChartFilters } from "@/hooks/use-chart-filters";
import { validateStatisticsSearch } from "@/lib/statistics";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/episodes/$episodeId/stats")({
	component: Page,
	params: z.object({
		episodeId: z.coerce.number(),
	}),
	validateSearch: validateStatisticsSearch,
	loaderDeps: (route) => ({
		search: route.search,
	}),
	async loader({ context, params, preload, deps }) {
		if (!preload) {
			return;
		}

		context.queryClient.prefetchQuery(
			orpc.statistics.downloads.queryOptions({
				input: {
					episodeId: params.episodeId,
					from: deps.search.from,
					to: deps.search.to,
				},
			}),
		);
	},
});

function Page() {
	const params = Route.useParams();
	const search = Route.useSearch();

	const chartFilters = useChartFilters({
		allStartDate: new Date("2025-01-01"),
		initialFilter: search.q,
		initialDate:
			search.from && search.to
				? { from: new Date(search.from), to: new Date(search.to) }
				: undefined,
	});

	return (
		<div className="grid grid-cols-12 gap-6 px-4 lg:px-6">
			<div className="col-span-full">
				<ChartFilters hook={chartFilters} className="px-4 lg:px-6" />
			</div>
			<DownloadsChart
				hook={chartFilters}
				episodeIds={[params.episodeId]}
				className="col-span-full"
			/>
		</div>
	);
}
